let frame: HTMLIFrameElement | null = null;
let frameUrl: string | null = null;

const release = () => {
  frame?.remove();
  frame = null;
  if (frameUrl) URL.revokeObjectURL(frameUrl);
  frameUrl = null;
};

/** Czas na załadowanie PDF-a w ramce; potem PDF otwiera się w nowej karcie. */
const LOAD_TIMEOUT_MS = 15000;
/** Przeglądarkowy podgląd PDF bywa niegotowy zaraz po onload — krótka zwłoka przed print(). */
const PRINT_DELAY_MS = 300;

/**
 * Otwiera systemowe okno drukowania dla PDF-a (niewidoczna ramka z podglądem PDF przeglądarki).
 * Ramka ma 1 × 1 px poza ekranem (ramka 0 × 0 potrafi nie wyrenderować PDF-a w Chromium)
 * i zostaje do następnego wydruku — usunięcie jej przy otwartym oknie drukowania przerywa
 * wydruk. Gdy drukowanie z ramki się nie uda albo PDF nie załaduje się w czasie (np. wyłączony
 * podgląd PDF — przeglądarka pobiera plik), PDF otwiera się w nowej karcie.
 */
export const printPdfBlob = (blob: Blob): Promise<void> =>
  new Promise((resolve, reject) => {
    release();

    const url = URL.createObjectURL(blob);
    const iframe = document.createElement("iframe");
    iframe.setAttribute("aria-hidden", "true");
    iframe.setAttribute("tabindex", "-1");
    iframe.style.position = "fixed";
    iframe.style.left = "-10000px";
    iframe.style.top = "0";
    iframe.style.width = "1px";
    iframe.style.height = "1px";
    iframe.style.border = "0";
    iframe.style.opacity = "0";
    iframe.src = url;

    let settled = false;
    const openInTab = () => {
      if (settled) return;
      settled = true;
      if (window.open(url, "_blank")) resolve();
      else reject(new Error("Przeglądarka zablokowała okno wydruku — zezwól na wyskakujące okna."));
    };
    const timeout = window.setTimeout(openInTab, LOAD_TIMEOUT_MS);

    iframe.onload = () => {
      window.clearTimeout(timeout);
      window.setTimeout(() => {
        if (settled) return;
        try {
          iframe.contentWindow?.focus();
          iframe.contentWindow?.print();
          settled = true;
          resolve();
        } catch {
          openInTab();
        }
      }, PRINT_DELAY_MS);
    };

    frame = iframe;
    frameUrl = url;
    document.body.appendChild(iframe);
  });

/** Pobranie PDF-a jako pliku. */
export const downloadPdfBlob = (blob: Blob, fileName: string) => {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = fileName.toLowerCase().endsWith(".pdf") ? fileName : `${fileName}.pdf`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 30000);
};
